<template>
   <section class="four-oh-four">
      <h3 class="blue">{{ err?.statusCode ?? 404 }}</h3>
      <h1>
         {{
            err?.statusMessage ??
            "The page you are looking for doesn't exist or is temporarily unavailable."
         }}
      </h1>
      <Btn text="Return Home" action @handle-action="handleError(error)" />
   </section>
</template>

<script setup lang="ts">
const err = useError();
// >> Methods
// Handle Error
const handleError = () => {
   clearError({ redirect: "/" });
   // fallback
   window.location = "/";
};
</script>

<style lang="scss" scoped>
section.four-oh-four {
   @include flex(column, center, center);
   @include px(1, 1, 1);
   padding-top: pad(15);
   padding-bottom: pad(15);
   text-align: center;
   align-items: center;
   > * {
      max-width: 800px;
   }

   .button {
      display: inline-flex;
   }

   @media #{$mobile} {
      min-height: auto;
      @include px(0, 0, 1);
      padding-top: pad(10);
      padding-bottom: pad(10);
      text-align: center;
      h1 {
         text-align: center;
      }
      .button {
         margin: 0 auto;
      }
   }
}
</style>
